// @flow
import { default as DynamoDbDriver } from "./DynamoDbDriver";

export { DynamoDbDriver };
